import { useMetrics } from "hooks/useMetrics";
const metricNames = {
  size: "org.graylog.plugins.datalake.output.journal.size",
  sizeLimit: "org.graylog.plugins.datalake.output.journal.size-limit",
  segments: "org.graylog.plugins.datalake.output.journal.numberOfSegments",
  messageUncommitted: "org.graylog.plugins.datalake.output.journal.uncommittedMessages",
  unflushedMessages: "org.graylog.plugins.datalake.output.journal.unflushedMessages",
  oldestSegment: "org.graylog.plugins.datalake.output.journal.oldest-segment"
};
const metricValues = Object.values(metricNames);
const gaugeValue = (metricsByNode, nodeId, fullName) => {
  var _a;
  const metric = (_a = metricsByNode[nodeId]) == null ? void 0 : _a[fullName];
  return (metric == null ? void 0 : metric.type) === "gauge" && typeof metric.metric.value === "number" ? metric.metric.value : 0;
};
const sumAcrossNodes = (metricsByNode, fullName) => Object.keys(metricsByNode).reduce((sum, nodeId) => sum + gaugeValue(metricsByNode, nodeId, fullName), 0);
const oldestSegmentAcrossNodes = (metricsByNode) => {
  const timestamps = Object.keys(metricsByNode).map((nodeId) => gaugeValue(metricsByNode, nodeId, metricNames.oldestSegment)).filter((v) => v > 0);
  return timestamps.length > 0 ? Math.min(...timestamps) : void 0;
};
const useClusterDataLakeJournalMetrics = () => {
  const { data: metricsByNode, isLoading } = useMetrics(metricValues);
  return {
    size: sumAcrossNodes(metricsByNode, metricNames.size),
    sizeLimit: sumAcrossNodes(metricsByNode, metricNames.sizeLimit),
    segments: sumAcrossNodes(metricsByNode, metricNames.segments),
    messageUncommitted: sumAcrossNodes(metricsByNode, metricNames.messageUncommitted),
    unflushedMessages: sumAcrossNodes(metricsByNode, metricNames.unflushedMessages),
    oldestSegment: oldestSegmentAcrossNodes(metricsByNode),
    isLoading
  };
};
export default useClusterDataLakeJournalMetrics;
